import { StateDOELogoContainer, StateDOEMobileLogoContainer } from './styles';
import { CONNECT_JOBBOARD_STATES } from 'utils/constants';
import { StateDOELogoProps } from '../types';

export const StateDOELogo: React.FC<StateDOELogoProps> = ({ jobBoardState, isMobile }) => {
  const logoToShow = CONNECT_JOBBOARD_STATES[jobBoardState]?.logo;
  const LogoContainer = isMobile ? StateDOEMobileLogoContainer : StateDOELogoContainer;

  return (
    <LogoContainer
      src={logoToShow}
      sx={isMobile ? { pr: 1 } : {}}
      alt="nimbleLogo"
      data-testid={`${CONNECT_JOBBOARD_STATES[jobBoardState]?.urlParam}-navbar-logo`}
    />
  );
};
